import { requireAuth } from '@/router/helpers';

/**
 * FE routes
 */
const FeRoutes = [
];

const AdminRoutes = [
  {
    path: '/admin/files',
    name: 'AdminFilesIndexPage',
    component: () => import('@/views/Files/admin/Index'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: '/admin/files/create',
    name: 'AdminFilesCreate',
    components: {
      default: () => import('@/views/Files/admin/Index'),
      panel: () => import('@/views/Files/admin/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
      openPanel: true
    },
  },
  {
    path: '/admin/file/:id',
    name: 'AdminFilesView',
    components: {
      default: () => import('@/views/Files/admin/Index'),
      panel: () => import('@/views/Files/admin/View'),
    },
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
      openPanel: true
    },
  },
  {
    path: '/admin/file/:id/edit',
    name: 'AdminFilesEdit',
    components: {
      default: () => import('@/views/Files/admin/Index'),
      panel: () => import('@/views/Files/admin/AddEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
      openPanel: true
    },
  },
];

export default AdminRoutes;
